<template>
  <mu-paper class="demo-list-wrap">
    <div v-if="isStudent" class="low-level">
      <div class="personal-header">
        <div class="position">
          <div class="avatar animated bounceIn">
            <img :src="$root.$data.wechatInfo.headimgurl" class="img-100" />
          </div>
          <div class="info">
            <h2 class="name">{{ $root.$data.wechatInfo.nickname }}</h2>
            <h4 class="mobile">
              {{ '联系方式：' + $root.$data.wechatInfo.mobile }}
            </h4>
          </div>
        </div>
      </div>

      <mu-list class="person-center-list" textline="two-line">
        <mu-list-item
          :to="{ path: '/wrong-title', query: {} }"
          :ripple="false"
          avatar
          button
          class="person-center-item wrong-question"
        >
          <mu-list-item-action>
            <mu-icon value="receipt"></mu-icon>
          </mu-list-item-action>
          <mu-list-item-title>错题集</mu-list-item-title>
          <mu-list-item-action>
            <mu-button icon>
              <mu-icon value="chevron_right"></mu-icon>
            </mu-button>
          </mu-list-item-action>
        </mu-list-item>
        <mu-list-item
          :to="{ path: '/test-records', query: {} }"
          :ripple="false"
          avatar
          button
          class="person-center-item examination"
        >
          <mu-list-item-action>
            <mu-icon value="watch_later"></mu-icon>
          </mu-list-item-action>
          <mu-list-item-title>考试记录</mu-list-item-title>
          <mu-list-item-action>
            <mu-button icon>
              <mu-icon value="chevron_right"></mu-icon>
            </mu-button>
          </mu-list-item-action>
        </mu-list-item>

        <mu-list-item
          :to="{
            path: '/record',
            query: {},
          }"
          :ripple="false"
          avatar
          button
          class="person-center-item record"
        >
          <mu-list-item-action>
            <mu-icon value="pageview"></mu-icon>
          </mu-list-item-action>
          <mu-list-item-title>观看记录</mu-list-item-title>
          <mu-list-item-action>
            <mu-button icon>
              <mu-icon value="chevron_right"></mu-icon>
            </mu-button>
          </mu-list-item-action>
        </mu-list-item>

        <mu-list-item
          :to="{ path: '/certificateList', query: {} }"
          :ripple="false"
          avatar
          button
          class="person-center-item e-certificate"
        >
          <mu-list-item-action>
            <mu-icon value="art_track"></mu-icon>
          </mu-list-item-action>
          <mu-list-item-title>电子证书</mu-list-item-title>
          <mu-list-item-action>
            <mu-button icon>
              <mu-icon value="chevron_right"></mu-icon>
            </mu-button>
          </mu-list-item-action>
        </mu-list-item>

        <mu-list-item
          :to="{ path: '/order', query: {} }"
          :ripple="false"
          avatar
          button
          class="person-center-item shop-online"
        >
          <mu-list-item-action>
            <mu-icon value="shopping_cart"></mu-icon>
          </mu-list-item-action>
          <mu-list-item-title>在线购买</mu-list-item-title>
          <mu-list-item-action>
            <mu-button icon>
              <mu-icon value="chevron_right"></mu-icon>
            </mu-button>
          </mu-list-item-action>
        </mu-list-item>

        <mu-list-item
          :to="{ path: '/order-list', query: {} }"
          :ripple="false"
          avatar
          button
          class="person-center-item orders"
        >
          <mu-list-item-action>
            <mu-icon value="view_list"></mu-icon>
          </mu-list-item-action>
          <mu-list-item-title>订单列表</mu-list-item-title>
          <mu-list-item-action>
            <mu-button icon>
              <mu-icon value="chevron_right"></mu-icon>
            </mu-button>
          </mu-list-item-action>
        </mu-list-item>

        <!-- <mu-list-item avatar
                      button 
                     @click="$root.$data.isStudent = !$root.$data.isStudent;"
                      :ripple="false"
                      class="person-center-item wrong-question">
          <mu-list-item-action>
            <mu-icon value="receipt"></mu-icon>
          </mu-list-item-action>
          <mu-list-item-title>!dev</mu-list-item-title>
          <mu-list-item-action>
            <mu-button icon>
              <mu-icon value="chevron_right"></mu-icon>
            </mu-button>
          </mu-list-item-action>
        </mu-list-item> -->
      </mu-list>
    </div>
    <div v-if="!isStudent" class="shadow middle-level"></div>

    <div
      v-if="!isStudent"
      :class="{ 'in-bind-state': inBindState }"
      class="register-wrap high-level"
    >
      <div class="color-chunk">
        <div class="icon-bg">
          <i class="material-icons">
            account_circle
          </i>
        </div>

        <h2 class="register-title">
          用户绑定
          <!-- 现在可以允许非学员自己绑定了 -->
          <!-- <small class="small">
          还未报名的用户，需成功
          <a :href="$root.$data.REGISTRATION_URL" class="link">报名</a>
          才能绑定!
        </small> -->
        </h2>
      </div>

      <div class="sign-in-content">
        <mu-text-field
          v-model="form.phone"
          :error-text="error.phone"
          placeholder="手机号码"
          type="number"
          color="#e2c869"
          icon="phone_android"
          underline-color="#5985fe"
        ></mu-text-field>
        <mu-text-field
          v-model="form.qrcode"
          :error-text="error.qrcode"
          placeholder="验证码"
          type="text"
          icon="verified_user"
          color="#e2c869"
          underline-color="#5985fe"
        >
          <mu-chip
            style="
              background: transparent;
              color: #e2c869;
              border: 1px solid #e2c869;
              height: 30px;
              margin: 6px 0;
            "
            @click="getVerificationCode(form.phone)"
          >
            {{ codeInfo.text }}
          </mu-chip>
        </mu-text-field>

        <mu-flex class="bind-wrapper" justify-content="around">
          <mu-button
            color="#5985fe"
            full-width
            @click="confirm(form.phone, form.qrcode)"
          >
            绑 定
          </mu-button>
        </mu-flex>
      </div>
    </div>
  </mu-paper>
</template>

<script>
import { fetchPhoneSignUpCode, fetchPhoneSignUpVerify } from '@/api/index'

export default {
  components: {},
  props: {},
  data() {
    return {
      auth: null,
      disableCode: true,
      inBindState: false,

      error: {
        phone: '',
        qrcode: '',
      },
      form: {
        number: '',
        qrcode: '',
        test: '',
      },
      codeInfo: {
        status: false,
        text: '获取验证码',
        sent: false,
      },
    }
  },
  computed: {
    isStudent: {
      get() {
        console.log('isStudent:get(): ', this.$root.$data)
        return this.$root.$data.isStudent
      },
      set(boolean) {
        console.log('isStudent:set() this.$root.$data.isStudent = ', boolean)
        this.$root.$data.isStudent = boolean
        return boolean
      },
    },
  },
  watch: {},
  created() {},
  mounted() {},
  activited() {},
  update() {},
  beforeRouteUpdate() {},
  methods: {
    bindAccount() {
      this.inBindState ? (this.inBindState = false) : (this.inBindState = true)
      this.inBindState = true
    },
    cancelBind() {
      this.inBindState = false
    },
    verifyPhone() {
      const reg = /^[1][3-9][0-9]{9}$/
      // const reg = /./;
      const result = reg.test(this.form.phone)
      result
        ? (this.error.phone = '')
        : (this.error.phone = '请输入正确的手机号码')
      return result
    },
    verifyCode() {
      const r = Boolean(this.form.qrcode)
      r ? (this.error.qrcode = '') : (this.error.qrcode = '请输入验证码')
      return r
    },
    confirm(phone, qrcode) {
      if (!this.verifyPhone() || !this.verifyCode()) return

      fetchPhoneSignUpVerify({ mobile: phone, code: qrcode }).then(() => {
        this.$NewToast.success('绑定成功~')
        this.isStudent = true
        window.location.reload()
      })
    },
    async getVerificationCode(phone) {
      if (this.codeInfo.status) return
      if (!this.verifyPhone()) return
      let sec = 60

      await fetchPhoneSignUpCode({ mobile: phone })
        .then(() => {
          this.disableCode = false
        })
        .catch(() => {
          sec = 10
        })
      this.codeInfo.status = true
      const _this = this
      setTimeout(function CountDown() {
        if (sec > 0) {
          sec--
          _this.codeInfo.text = `${sec} s`
          setTimeout(CountDown, 1000)
        } else {
          _this.codeInfo.text = `重新获取`
          _this.codeInfo.status = false
        }
      }, 0)
    },
  },
  filter: {},
}
</script>

<style lang="scss" scoped>
.color-chunk {
  // background-color: #214ecf;
  background-image: url('../assets/images/person-center-bind-bg.png');
  background-size: 100% 100%;

  width: 100%;
  height: 40%;
  position: relative;

  .material-icons {
    position: absolute;
    top: 40px;
    font-size: 80px;
    color: #fff;
    border-radius: 50%;
    background-color: #999;
    left: 50%;
    transform: translate(-50%, 0%);
  }
}
.personal-header {
  width: 100%;
  // background-color: #214ecf;
  background-image: url('../assets/images/person-center-bg.png');
  text-align: center;
  position: relative;
  background-size: 100% 100%;
  height: 156px;

  .position {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 35px 24px;

    .avatar {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      overflow: hidden;
      border: 2px solid #fff;
    }

    .info {
      color: #fff;
      margin: 0 0 0 12px;
      text-align: start;
      .name {
        margin: 0;
      }
      .mobile {
        margin: 4px 0 0 0;
      }
    }
  }
}
.small {
  font-size: 0.4em;
  color: #666;
  .link {
    text-decoration: none;
    color: #f1321a;
    font-size: 1.18em;
  }
}
.shadow {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 56px;
  background-color: rgba(0, 0, 0, 0.4);
  background-color: #fff;
  background: url(../assets/Q2.jpg) no-repeat;
  background-size: cover;
}
.smaller-font-size {
  font-size: 0.9em;
}

.register-wrap {
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 56px;
  overflow-y: scroll;
  background-color: #fff;
  margin: auto;
  padding: {
    bottom: 56px;
  }
}
.register {
  width: 250px;
  height: 50px;
  line-height: 50px;
  font-size: 1.5em;
  text-align: center;
  margin: {
    top: 30px;
    left: auto;
    right: auto;
  }
}

.person-center-list {
  padding: 0;
  background-color: #fff;
  margin: 0 12px;
  margin-top: -35px;
  border-radius: 12px;
  box-shadow: 0px 8px 10px 2px rgba(206, 206, 206, 0.5);
  width: calc(100% - 24px);
  min-height: calc(100vh - 249px);
}
.person-center-item {
  &:after {
    content: '';
    height: 1px;
    width: 90%;
    margin: auto;
    display: block;
    background-color: #eee;
  }
}
</style>

<style lang="scss">
.person-center-list {
  .person-center-item {
    .mu-item {
      height: 50px;
      padding: 0;
      margin: 8px 16px;
      & > .mu-item-action {
        min-width: 36px;
        & > .mu-icon {
          color: #d55a5e;
        }
      }
    }
  }
  .person-center-item.examination .mu-item .mu-item-action .mu-icon {
    color: #99a3f3;
  }
  .person-center-item.record .mu-item .mu-item-action .mu-icon {
    color: #f39999;
  }
  .person-center-item.wrong-question .mu-item .mu-item-action .mu-icon {
    color: #97c4a0;
  }
  .person-center-item.e-certificate .mu-item .mu-item-action .mu-icon {
    color: #c497be;
  }
  .person-center-item.shop-online .mu-item .mu-item-action .mu-icon {
    color: #f5bd67;
  }
  .person-center-item.orders .mu-item .mu-item-action .mu-icon {
    color: #99caef;
  }
}
.register-title {
  color: #fff;
  font-weight: normal;
  font-size: 20px;
  margin: 0;
  transform: translate(-50%, 0%);
  position: absolute;
  left: 50%;
  top: 136px;

  .small {
    display: block;
  }
}
.in-bind-state {
  transform: translate(-50%, -50%);
  // transition: 0.6s ease-in-out;
  .sign-up {
    opacity: 0;
    display: none;
  }

  .sign-in {
    background-color: transparent;
    color: black;
    margin-left: 0;
    text-align: left;
    box-shadow: none;
    font-size: 2em;
    line-height: 1.25;
  }
}
.sign-in-content {
  width: 100%;
  text-align: center;
  padding: 0 15px 15px;

  .mu-input.has-label {
    padding-right: 17px;
  }
  .mu-input {
    left: -7px;
    width: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
  }
  .material-icons {
    color: rgb(89, 133, 254);
  }
}
.bind-wrapper {
  margin-top: 30px;
  .mu-button-full-width {
    border-radius: 30px;
    width: 70%;
    height: 40px;
  }
  .mu-raised-button {
    box-shadow: none;
    font-size: 1.3em;
  }
}
</style>
